(function () {
  "use strict";

  function waitForGSAP(cb) {
    if (window.gsap && window.ScrollTrigger) { cb(); return; }
    const t = setInterval(() => {
      if (window.gsap && window.ScrollTrigger) { clearInterval(t); cb(); }
    }, 50);
  }

  document.addEventListener("DOMContentLoaded", () => { waitForGSAP(initFDH); });

  function initFDH() {
    gsap.registerPlugin(ScrollTrigger);
    const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    injectDOM();
    initScrollProgress();
    if (!prefersReduced) {
      initCursor();
      initParticleCanvas();
      initRevealAnimations();
      initStaggerGrids();
      initCardTilt3D();
      initMagneticButtons();
      initParallaxImages();
      initTextSplits();
      initCounters();
      initMarquee();
      initPageTransition();
    }
    initProductCardHover();
  }

  function injectDOM() {
    if (!document.getElementById("fdh-scroll-progress")) {
      const bar = document.createElement("div");
      bar.id = "fdh-scroll-progress";
      document.body.prepend(bar);
    }
    if (!document.getElementById("fdh-cursor")) {
      const dot = document.createElement("div");
      dot.id = "fdh-cursor";
      const ring = document.createElement("div");
      ring.id = "fdh-cursor-ring";
      document.body.append(dot, ring);
    }
    if (!document.getElementById("fdh-page-veil")) {
      const veil = document.createElement("div");
      veil.id = "fdh-page-veil";
      document.body.append(veil);
    }
    if (!document.getElementById("fdh-particle-canvas")) {
      const canvas = document.createElement("canvas");
      canvas.id = "fdh-particle-canvas";
      document.body.prepend(canvas);
    }
    autoTagElements();
  }

  function autoTagElements() {
    document.querySelectorAll('.collection, .product-grid, [class*="product-grid"], ul.grid')
      .forEach(g => g.classList.add("fdh-stagger-grid"));

    document.querySelectorAll("h1, h2, .h1, .h2").forEach(el => {
      if (!el.closest("[data-no-split]")) el.classList.add("fdh-split-heading");
    });

    document.querySelectorAll(
      ".rich-text__text, .rich-text__heading, .collage__item, .multicolumn-card, p.caption, .section-header"
    ).forEach(el => el.classList.add("fdh-reveal-up"));

    document.querySelectorAll(
      ".banner__media, .hero__media, .featured-image, .collage__item img, .media-with-text__media"
    ).forEach(el => {
      if (el.closest(".media")) el.closest(".media").classList.add("fdh-img-parallax");
    });

    document.querySelectorAll(".card--product, .card-wrapper").forEach(el => {
      el.classList.add("fdh-card-3d");
      const shine = document.createElement("div");
      shine.className = "fdh-card-3d__shine";
      el.style.position = "relative";
      el.appendChild(shine);
    });

    document.querySelectorAll('.button--primary, .btn-primary, [class*="button--primary"]').forEach(el => {
      if (!el.closest(".fdh-magnetic")) {
        const wrap = document.createElement("span");
        wrap.className = "fdh-magnetic";
        const inner = document.createElement("span");
        inner.className = "fdh-magnetic__inner";
        el.parentNode.insertBefore(wrap, el);
        inner.appendChild(el.cloneNode(true));
        wrap.appendChild(inner);
        el.parentNode.removeChild(el);
      }
    });
  }

  function initScrollProgress() {
    const bar = document.getElementById("fdh-scroll-progress");
    if (!bar) return;
    gsap.set(bar, { scaleX: 0, transformOrigin: "left" });
    gsap.to(bar, {
      scaleX: 1,
      ease: "none",
      scrollTrigger: { trigger: document.body, start: "top top", end: "bottom bottom", scrub: 0.3 }
    });
  }

  function initCursor() {
    const dot = document.getElementById("fdh-cursor");
    const ring = document.getElementById("fdh-cursor-ring");
    if (!dot || !ring) return;
    gsap.set([dot, ring], { xPercent: -50, yPercent: -50 });

    let mouseX = 0, mouseY = 0, ringX = 0, ringY = 0;

    document.addEventListener("mousemove", e => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      gsap.to(dot, { x: mouseX, y: mouseY, duration: 0.08, ease: "power3.out" });
    });

    (function animateRing() {
      ringX += (mouseX - ringX) * 0.12;
      ringY += (mouseY - ringY) * 0.12;
      gsap.set(ring, { x: ringX, y: ringY });
      requestAnimationFrame(animateRing);
    })();

    document.querySelectorAll("a, button, .fdh-card-3d, .fdh-magnetic").forEach(el => {
      el.addEventListener("mouseenter", () => document.body.classList.add("fdh-cursor--hover"));
      el.addEventListener("mouseleave", () => document.body.classList.remove("fdh-cursor--hover"));
    });

    document.addEventListener("mouseleave", () => gsap.to([dot, ring], { opacity: 0, duration: 0.3 }));
    document.addEventListener("mouseenter", () => gsap.to([dot, ring], { opacity: 1, duration: 0.3 }));
  }

  function initParticleCanvas() {
    const canvas = document.getElementById("fdh-particle-canvas");
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let W, H, particles = [];
    const COUNT = 55;
    const COLORS = ["#2d7a2d", "#5cc85c", "#a8e063", "#ffffff"];

    function resize() { W = canvas.width = window.innerWidth; H = canvas.height = window.innerHeight; }
    function mkParticle() {
      return {
        x: Math.random() * W, y: Math.random() * H,
        r: Math.random() * 2 + 0.5,
        dx: (Math.random() - 0.5) * 0.35,
        dy: (Math.random() - 0.5) * 0.35,
        color: COLORS[Math.floor(Math.random() * COLORS.length)],
        alpha: Math.random() * 0.6 + 0.2
      };
    }

    resize();
    window.addEventListener("resize", resize);
    particles = Array.from({ length: COUNT }, mkParticle);

    (function draw() {
      ctx.clearRect(0, 0, W, H);
      particles.forEach(p => {
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = p.color;
        ctx.globalAlpha = p.alpha;
        ctx.fill();
        p.x += p.dx; p.y += p.dy;
        if (p.x < -10) p.x = W + 10;
        if (p.x > W + 10) p.x = -10;
        if (p.y < -10) p.y = H + 10;
        if (p.y > H + 10) p.y = -10;
      });
      ctx.globalAlpha = 1;
      requestAnimationFrame(draw);
    })();
  }

  function initRevealAnimations() {
    [
      { sel: ".fdh-reveal",       from: { opacity: 0 },               to: { opacity: 1 } },
      { sel: ".fdh-reveal-up",    from: { opacity: 0, y: 60 },        to: { opacity: 1, y: 0 } },
      { sel: ".fdh-reveal-left",  from: { opacity: 0, x: -60 },       to: { opacity: 1, x: 0 } },
      { sel: ".fdh-reveal-right", from: { opacity: 0, x: 60 },        to: { opacity: 1, x: 0 } },
      { sel: ".fdh-reveal-scale", from: { opacity: 0, scale: 0.88 },  to: { opacity: 1, scale: 1 } },
    ].forEach(({ sel, from, to }) => {
      document.querySelectorAll(sel).forEach(el => {
        gsap.fromTo(el, from, {
          ...to,
          duration: 1.1,
          ease: "power3.out",
          scrollTrigger: { trigger: el, start: "top 88%", once: true }
        });
      });
    });
  }

  function initStaggerGrids() {
    document.querySelectorAll(".fdh-stagger-grid").forEach(grid => {
      const items = grid.children;
      if (!items.length) return;
      gsap.fromTo(
        items,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 0.85,
          ease: "power3.out",
          stagger: 0.12,
          scrollTrigger: { trigger: grid, start: "top 85%", once: true }
        }
      );
    });
  }

  function initCardTilt3D() {
    document.querySelectorAll(".fdh-card-3d").forEach(card => {
      const shine = card.querySelector(".fdh-card-3d__shine");
      const MAX = 12;
      card.addEventListener("mousemove", e => {
        const rect = card.getBoundingClientRect();
        const dx = (e.clientX - (rect.left + rect.width / 2)) / (rect.width / 2);
        const dy = (e.clientY - (rect.top + rect.height / 2)) / (rect.height / 2);
        gsap.to(card, { rotateX: -dy * MAX, rotateY: dx * MAX, scale: 1.03, duration: 0.4, ease: "power2.out", transformPerspective: 900 });
        if (shine) {
          gsap.to(shine, {
            opacity: 0.7,
            background: `radial-gradient(circle at ${(dx + 1) / 2 * 100}% ${(dy + 1) / 2 * 100}%, rgba(255,255,255,0.22) 0%, transparent 65%)`,
            duration: 0.3
          });
        }
      });
      card.addEventListener("mouseleave", () => {
        gsap.to(card, { rotateX: 0, rotateY: 0, scale: 1, duration: 0.6, ease: "power3.out" });
        if (shine) gsap.to(shine, { opacity: 0, duration: 0.4 });
      });
    });
  }

  function initMagneticButtons() {
    document.querySelectorAll(".fdh-magnetic").forEach(wrap => {
      const inner = wrap.querySelector(".fdh-magnetic__inner");
      if (!inner) return;
      const STRENGTH = 0.4;
      wrap.addEventListener("mousemove", e => {
        const rect = wrap.getBoundingClientRect();
        const dx = e.clientX - (rect.left + rect.width / 2);
        const dy = e.clientY - (rect.top + rect.height / 2);
        gsap.to(inner, { x: dx * STRENGTH, y: dy * STRENGTH, duration: 0.4, ease: "power2.out" });
      });
      wrap.addEventListener("mouseleave", () => {
        gsap.to(inner, { x: 0, y: 0, duration: 0.6, ease: "elastic.out(1, 0.5)" });
      });
    });
  }

  function initParallaxImages() {
    document.querySelectorAll(".fdh-img-parallax").forEach(wrap => {
      const img = wrap.querySelector("img, .img-inner, .media__img");
      if (!img) return;
      gsap.fromTo(img, { y: "-8%" }, {
        y: "8%",
        ease: "none",
        scrollTrigger: { trigger: wrap, start: "top bottom", end: "bottom top", scrub: 1.5 }
      });
    });
  }

  function initTextSplits() {
    if (!window.SplitType) return;
    document.querySelectorAll(".fdh-split-heading").forEach(el => {
      if (el.closest(".shopify-section-editor")) return;
      try {
        const split = new SplitType(el, { types: "words" });
        gsap.from(split.words, {
          opacity: 0, y: 40, rotateX: -30,
          transformOrigin: "0% 50% -50px",
          stagger: 0.06, duration: 0.85, ease: "back.out(1.5)",
          scrollTrigger: { trigger: el, start: "top 90%", once: true }
        });
      } catch (_) {}
    });
  }

  function initCounters() {
    document.querySelectorAll(".fdh-counter, [data-counter]").forEach(el => {
      const target = parseFloat(el.dataset.counter || el.textContent) || 0;
      const obj = { val: 0 };
      gsap.to(obj, {
        val: target, duration: 2, ease: "power2.out",
        onUpdate: () => {
          el.textContent = Number.isInteger(target)
            ? Math.round(obj.val).toLocaleString()
            : obj.val.toFixed(1);
        },
        scrollTrigger: { trigger: el, start: "top 85%", once: true }
      });
    });
  }

  function initMarquee() {
    document.querySelectorAll(".fdh-marquee-track").forEach(track => {
      const inner = track.querySelector(".fdh-marquee-inner");
      if (!inner) return;
      track.appendChild(inner.cloneNode(true));
    });
  }

  function initProductCardHover() {
    document.querySelectorAll(".card-wrapper").forEach(c => { c.style.willChange = "transform"; });
  }

  function initPageTransition() {
    const veil = document.getElementById("fdh-page-veil");
    if (!veil) return;
    gsap.fromTo(veil, { yPercent: 0 }, { yPercent: -100, duration: 0.85, ease: "power3.inOut", delay: 0.05 });
    document.querySelectorAll("a[href]").forEach(link => {
      const href = link.getAttribute("href");
      if (
        !href ||
        href.startsWith("#") ||
        href.startsWith("http") ||
        href.startsWith("mailto") ||
        href.startsWith("tel") ||
        link.target === "_blank" ||
        href.includes("/cart") ||
        href.includes("checkout")
      ) return;
      link.addEventListener("click", e => {
        e.preventDefault();
        gsap.fromTo(veil, { yPercent: 100 }, {
          yPercent: 0, duration: 0.55, ease: "power3.in",
          onComplete: () => { window.location = href; }
        });
      });
    });
  }

})();

(function () {
  "use strict";

  var LOGO = "https://cdn.shopify.com/s/files/1/0699/4680/2400/files/IMG_3745-2.png";

  if (
    sessionStorage.getItem("fdh-intro-done") ||
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  ) return;

  var style = document.createElement("style");
  style.textContent =
    "#fdh-intro-overlay{position:fixed;inset:0;background:#050f05;z-index:9999990;display:flex;align-items:center;justify-content:center;overflow:hidden;}" +
    "#fdh-intro-scene{position:relative;width:min(380px,85vw);height:min(380px,85vw);transform-style:preserve-3d;}" +
    "#fdh-intro-logo{width:100%;height:100%;object-fit:contain;position:relative;z-index:2;border-radius:16px;box-shadow:0 0 80px rgba(0,255,136,0.2);}" +
    "#fdh-smoke-canvas{position:absolute;inset:0;width:100%;height:100%;pointer-events:none;z-index:3;}" +
    "#fdh-intro-skip{position:fixed;bottom:28px;right:28px;font-family:-apple-system,BlinkMacSystemFont,sans-serif;font-size:13px;color:rgba(255,255,255,0.5);cursor:pointer;z-index:9999999;background:rgba(255,255,255,0.08);border:1px solid rgba(255,255,255,0.15);padding:8px 18px;border-radius:20px;transition:all 0.2s;letter-spacing:0.03em;}" +
    "#fdh-intro-skip:hover{color:#fff;background:rgba(255,255,255,0.15);}" +
    "#fdh-intro-flash{position:fixed;inset:0;background:#00ff88;opacity:0;pointer-events:none;z-index:9999995;}" +
    "#fdh-intro-tagline{position:absolute;bottom:-52px;left:50%;transform:translateX(-50%);white-space:nowrap;font-family:-apple-system,BlinkMacSystemFont,'Helvetica Neue',sans-serif;font-size:13px;letter-spacing:0.18em;text-transform:uppercase;color:rgba(0,255,136,0.7);z-index:5;}";
  document.head.appendChild(style);

  var overlay = document.createElement("div"); overlay.id = "fdh-intro-overlay";
  var scene   = document.createElement("div"); scene.id   = "fdh-intro-scene";
  var logo    = document.createElement("img"); logo.id    = "fdh-intro-logo";
  var canvas  = document.createElement("canvas"); canvas.id = "fdh-smoke-canvas";
  var tagline = document.createElement("p");   tagline.id = "fdh-intro-tagline";
  var skip    = document.createElement("button"); skip.id  = "fdh-intro-skip";
  var flash   = document.createElement("div"); flash.id   = "fdh-intro-flash";

  logo.src = LOGO; logo.alt = "Factory Direct Hydroponics";
  tagline.textContent = "Factory Direct Hydroponics";
  skip.textContent = "Skip \u2192";

  scene.appendChild(logo); scene.appendChild(canvas); scene.appendChild(tagline);
  overlay.appendChild(scene);
  document.body.appendChild(overlay);
  document.body.appendChild(skip);
  document.body.appendChild(flash);

  var ctx = canvas.getContext("2d");
  var particles = [], smokeActive = true, rafId;
  var CHIMNEYS = [{ x: 0.185, y: 0.075 }, { x: 0.475, y: 0.04 }, { x: 0.785, y: 0.075 }];

  function spawnParticle(ch) {
    return {
      x: ch.x * canvas.width, y: ch.y * canvas.height,
      vx: (Math.random() - 0.5) * 1,
      vy: -(Math.random() * 1.4 + 0.6),
      r: Math.random() * 7 + 3,
      alpha: Math.random() * 0.55 + 0.2,
      life: 0,
      maxLife: Math.random() * 90 + 60
    };
  }

  function tickSmoke() {
    canvas.width = scene.offsetWidth;
    canvas.height = scene.offsetHeight;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (smokeActive) {
      CHIMNEYS.forEach(ch => { if (Math.random() < 0.45) particles.push(spawnParticle(ch)); });
    }
    particles = particles.filter(p => p.life < p.maxLife);
    particles.forEach(p => {
      p.life++;
      p.x += p.vx + (Math.random() - 0.5) * 0.15;
      p.y += p.vy;
      p.vx += (Math.random() - 0.5) * 0.08;
      p.r += 0.12;
      var prog = p.life / p.maxLife;
      var alpha = p.alpha * (1 - prog * prog);
      var g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r);
      g.addColorStop(0, "rgba(180,220,190," + alpha + ")");
      g.addColorStop(1, "rgba(120,180,140,0)");
      ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fillStyle = g; ctx.fill();
    });
    rafId = requestAnimationFrame(tickSmoke);
  }

  function dismiss(fast) {
    sessionStorage.setItem("fdh-intro-done", "1");
    cancelAnimationFrame(rafId);
    if (fast) { overlay.remove(); skip.remove(); flash.remove(); style.remove(); return; }
    gsap.to(overlay, {
      opacity: 0, duration: 0.55, ease: "power2.in",
      onComplete: () => { overlay.remove(); skip.remove(); flash.remove(); style.remove(); }
    });
  }

  skip.addEventListener("click", () => dismiss(true));

  logo.onload = function () {
    rafId = requestAnimationFrame(tickSmoke);
    gsap.set(scene, { scale: 0.9, opacity: 0 });
    gsap.set(tagline, { opacity: 0, y: 10 });
    gsap.timeline({ delay: 0.2 })
      .to(scene,   { scale: 1, opacity: 1, duration: 1, ease: "power2.out" })
      .to(tagline, { opacity: 1, y: 0, duration: 0.8, ease: "power2.out" }, "-=0.6")
      .to({}, { duration: 2.5 })
      .add(() => { smokeActive = false; })
      .to(tagline, { opacity: 0, duration: 0.4 }, "-=0.2")
      .to(scene,   { scale: 9, duration: 2.8, ease: "power2.inOut" }, "-=0.2")
      .to(flash,   { opacity: 1, duration: 0.12, ease: "power4.in" }, "-=0.1")
      .to(flash,   { opacity: 0, duration: 0.7, ease: "power2.out" })
      .add(() => { dismiss(false); }, "-=0.35");
  };

  logo.onerror = function () { setTimeout(() => dismiss(true), 1500); };
  if (logo.complete && logo.naturalWidth > 0) { logo.onload(); }

})();